// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign24CircleFilled: FC<Campaign24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm10-17h-4v2h4v-2Zm-6 6.6 3.2 2.4 1.2-1.6-3.2-2.4-1.2 1.6Zm0-11.2 1.2 1.6 3.2-2.4L23.2 8 20 10.4ZM9 19v4h2v-4h1l5 3V10l-5 3H8c-.55 0-1.02.196-1.413.588A1.926 1.926 0 0 0 6 15v2c0 .55.196 1.02.587 1.413C6.98 18.803 7.45 19 8 19h1Zm10.087-4.887A4.567 4.567 0 0 0 18 12.65v6.7c.45-.4.813-.888 1.087-1.463A4.318 4.318 0 0 0 19.5 16c0-.683-.137-1.313-.413-1.887Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Campaign24CircleFilled;
